// This file is auto-generated using the 'icon-generator' package.
// Any changes made to this file manually will be lost the next time the
// file is generated

import * as React from "react";
import { MappedProps, PassedProps, useMappedProps } from "./useMappedProps";

const Icon: React.ComponentType<
  Omit<React.SVGProps<SVGSVGElement>, keyof MappedProps> & PassedProps
> = (passedProps) => {
  const props = useMappedProps(passedProps);
  return (
    <svg
      width={91}
      height={90}
      viewBox="0 0 91 90"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <defs>
        <radialGradient
          id="AragIcon__b"
          cx={0}
          cy={0}
          r={1}
          gradientUnits="userSpaceOnUse"
          gradientTransform="rotate(42.19 -21.551 42.56) scale(64.9016)"
        >
          <stop stopColor="#FFF7AF" />
          <stop offset={0.42} stopColor="#FECF03" />
        </radialGradient>
        <clipPath id="AragIcon__a">
          <path
            fill="#fff"
            transform="translate(2.087 1.087)"
            d="M0 0h88v88H0z"
          />
        </clipPath>
        <filter
          id="AragIcon__c"
          x={12.245}
          y={32.106}
          width={65.602}
          height={26.689}
          filterUnits="userSpaceOnUse"
          colorInterpolationFilters="sRGB"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
            result="hardAlpha"
          />
          <feOffset dx={1} dy={2} />
          <feGaussianBlur stdDeviation={0.1} />
          <feComposite in2="hardAlpha" operator="out" />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1384_3727"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect1_dropShadow_1384_3727"
            result="shape"
          />
        </filter>
      </defs>
      <g clipPath="url(#AragIcon__a)">
        <path
          d="M44.087 89.087c24.3 0 44-19.7 44-44s-19.7-44-44-44-44 19.7-44 44 19.7 44 44 44Z"
          fill="url(#AragIcon__b)"
        />
      </g>
      <path
        fill="none"
        d="M87.706 44.603c0 23.805-19.298 43.103-43.103 43.103C20.798 87.706 1.5 68.408 1.5 44.603 1.5 20.798 20.798 1.5 44.603 1.5c23.805 0 43.103 19.298 43.103 43.103Z"
        stroke="#000"
        strokeWidth={3}
      />
      <g filter="url(#AragIcon__c)">
        <path d="M19.075 32.106c3.777 0 6.862 3.085 6.862 6.862v17.187h-3.966v-7.932h-5.76v7.932h-3.966V38.968c0-3.777 3.053-6.862 6.83-6.862 0 0 .032 0 0 0Zm-2.864 12.12h5.76v-5.289c0-1.574-1.29-2.864-2.864-2.896a2.908 2.908 0 0 0-2.896 2.896v5.288Zm19.17-11.71c4.312 0 7.837 3.525 7.837 7.837a7.762 7.762 0 0 1-2.959 6.107s-.063.031-.126.094l3.274 9.57h-4.218l-2.77-8.059c-.283.063-.787.095-1.07.095H33.05v7.932h-3.966v-23.64c0 .064 6.295.064 6.295.064Zm-2.33 11.678h2.298a3.869 3.869 0 0 0 3.871-3.872c0-2.14-1.73-3.872-3.84-3.872h-2.298l-.031 7.744Zm19.988-12.088c3.777 0 6.862 3.085 6.862 6.862v17.187h-3.966v-7.932h-5.76v7.932h-3.967V38.968c-.031-3.777 3.022-6.862 6.83-6.862-.03 0 0 0 0 0Zm-2.896 12.12h5.76v-5.289c0-1.574-1.29-2.864-2.864-2.896-1.574 0-2.865 1.29-2.865 2.896v5.288h-.031Zm19.642-12.12c-3.778 0-6.862 3.085-6.862 6.862v10.766c0 3.777 3.053 6.861 6.83 6.861s6.862-3.084 6.862-6.861v-5.477H69.69v3.966h2.959v1.51c0 1.574-1.29 2.896-2.864 2.896-1.574 0-2.865-1.29-2.865-2.895V38.968c0-1.573 1.29-2.864 2.896-2.864 1.605 0 2.864 1.322 2.864 3.022v.724h3.967v-.724a7.186 7.186 0 0 0-1.984-4.974 6.757 6.757 0 0 0-4.878-2.046s.031 0 0 0Z" />
      </g>
      <path
        d="M69.501 57.005c-3.872-.158-6.988-3.368-6.988-7.303V38.937a7.308 7.308 0 0 1 7.303-7.303c1.951 0 3.808.787 5.162 2.172 1.354 1.385 2.109 3.274 2.109 5.257v1.164H72.24v-1.164c0-1.448-1.07-2.581-2.424-2.581-.661 0-1.26.252-1.731.724a2.404 2.404 0 0 0-.724 1.73v10.766c0 1.354 1.101 2.455 2.423 2.455.661 0 1.26-.251 1.732-.724.472-.472.724-1.07.724-1.73v-1.071h-2.96v-4.848h7.807v5.918a7.237 7.237 0 0 1-2.14 5.162 7.248 7.248 0 0 1-4.91 2.14H69.5Zm-14.039-.441v-7.932h-4.879v7.932h-4.847V38.937a7.308 7.308 0 0 1 7.303-7.303 7.308 7.308 0 0 1 7.302 7.303v17.627h-4.879Zm0-12.78v-4.847c0-1.354-1.101-2.424-2.455-2.455a2.458 2.458 0 0 0-2.455 2.455v4.847h4.91Zm-16.557 12.78-2.738-7.995a8.633 8.633 0 0 1-.787.063h-1.857v7.932h-4.88v-24.52h6.737c4.564 0 8.247 3.714 8.247 8.278a8.24 8.24 0 0 1-2.99 6.358l3.4 9.853h-5.132v.031ZM35.38 43.753a3.38 3.38 0 0 0 2.424-1.007 3.38 3.38 0 0 0 1.007-2.424 3.44 3.44 0 0 0-3.431-3.431h-1.857v6.862h1.857ZM21.53 56.564v-7.932h-4.879v7.932h-4.847V38.937a7.308 7.308 0 0 1 7.302-7.303 7.308 7.308 0 0 1 7.303 7.303v17.627H21.53Zm0-12.78v-4.847c0-1.354-1.102-2.424-2.455-2.455a2.458 2.458 0 0 0-2.455 2.455v4.847h4.91Z"
        fill="#FFF042"
      />
      <path d="M19.075 32.106c3.777 0 6.862 3.085 6.862 6.862v17.187h-3.966v-7.932h-5.76v7.932h-3.966V38.968c0-3.777 3.053-6.862 6.83-6.862 0 0 .032 0 0 0Zm-2.864 12.12h5.76v-5.289c0-1.574-1.29-2.864-2.864-2.896a2.908 2.908 0 0 0-2.896 2.896v5.288Zm19.17-11.71c4.312 0 7.837 3.525 7.837 7.837a7.762 7.762 0 0 1-2.959 6.107s-.063.031-.126.094l3.274 9.57h-4.218l-2.77-8.059c-.283.063-.787.095-1.07.095H33.05v7.932h-3.966v-23.64c0 .064 6.295.064 6.295.064Zm-2.33 11.678h2.298a3.869 3.869 0 0 0 3.871-3.872c0-2.14-1.73-3.872-3.84-3.872h-2.298l-.031 7.744Zm19.988-12.088c3.777 0 6.862 3.085 6.862 6.862v17.187h-3.966v-7.932h-5.76v7.932h-3.967V38.968c-.031-3.777 3.022-6.862 6.83-6.862-.03 0 0 0 0 0Zm-2.896 12.12h5.76v-5.289c0-1.574-1.29-2.864-2.864-2.896-1.574 0-2.865 1.29-2.865 2.896v5.288h-.031Zm19.642-12.12c-3.778 0-6.862 3.085-6.862 6.862v10.766c0 3.777 3.053 6.861 6.83 6.861s6.862-3.084 6.862-6.861v-5.477H69.69v3.966h2.959v1.51c0 1.574-1.29 2.896-2.864 2.896-1.574 0-2.865-1.29-2.865-2.895V38.968c0-1.573 1.29-2.864 2.896-2.864 1.605 0 2.864 1.322 2.864 3.022v.724h3.967v-.724a7.186 7.186 0 0 0-1.984-4.974 6.757 6.757 0 0 0-4.878-2.046s.031 0 0 0Z" />
    </svg>
  );
};

const AragIcon = Icon;
export default AragIcon;
